import React, { useState } from 'react'
import { message, Form, Input, Modal, Row, Col, Button } from 'antd'
import { useSelector, useDispatch } from 'react-redux'
import IntlMessages from '../../util/IntlMessages'
import {
  loadParkedSaleModalvisible,
  loadSaleOrderJson,
  loadFormSellNote,
  loadIsFolderActive,
  loadActiveFolderData,
  loadQuicKeyDetails,
  loadQuickKeyCount
} from '../../appRedux/actions/MainSale'
import DefaultQuickKeyLayout from '../SetProductLayout'
import CustomScrollbars from '../../util/CustomScrollbars'
import { FolderOpenOutlined } from '@ant-design/icons'
import QuickKeys from './QuickKeys'

const QuickKeysModal = props => {
  const { selOutlet, show, setShow } = props
  const dispatch = useDispatch()

  const isOnline = useSelector(({ commonConfigs }) => commonConfigs.isOnline)
  const getParkedSaleModalVisible = useSelector(
    ({ MainSale }) => MainSale.getParkedSaleModalVisible
  )
  const getConfigSellLayout = useSelector(
    ({ commonConfigs }) => commonConfigs.getConfigSellLayout
  )
  const getIsFolderActive = useSelector(
    ({ MainSale }) => MainSale.getIsFolderActive
  )
  const getActiveColorCode = useSelector(
    ({ MainSale }) => MainSale.getActiveColorCode
  )
  const getActiveFolderData = useSelector(
    ({ MainSale }) => MainSale.getActiveFolderData
  )
  const getMainQuickKeysDetails = useSelector(
    ({ MainSale }) => MainSale.getMainQuickKeysDetails
  )
  const getQuickKeysDetails = useSelector(
    ({ MainSale }) => MainSale.getQuickKeysDetails
  )

  const onFolderCloseClick = () => {
    dispatch(loadIsFolderActive(false))
    dispatch(loadActiveFolderData([]))
    dispatch(loadQuicKeyDetails(getMainQuickKeysDetails))
    dispatch(loadQuickKeyCount({ rows: 5, columns: 5 }))
  }

  return (
    <Modal
      // title={
      //   <p className='dk-quick-modal-header'>
      //     <IntlMessages id='sell.sell.addanotetothesale' />
      //   </p>
      // }
      visible={show}
      // okText={<IntlMessages id='common.resource.save' />}
      // confirmLoading={confirmLoading}
      onCancel={() => {
        setShow(false)
      }}
      closable={false}
      // width={400}
      centered={true}
      footer={[
        <Button
          type='primary'
          // loading={confirmLoading}
          onClick={() => {
            setShow(false)
          }}
        >
          Close
        </Button>
      ]}
    >
      {getConfigSellLayout ? (
        <>
          {getIsFolderActive ? (
            <div
              className='dk-sale-quick-key-folder-header'
              style={{
                backgroundColor: getActiveColorCode
              }}
            >
              <FolderOpenOutlined style={{ float: 'left' }} />
              {getActiveFolderData.folderName}
              <i
                onClick={e => {
                  onFolderCloseClick()
                }}
                className='icon icon-close dk-quick-key-folder-action dk-quick-key-folder-action--close'
              ></i>
            </div>
          ) : (
            ''
          )}

          <CustomScrollbars className='gx-module-content-scroll gx-module-shortcut-scroll  dk-sale-shortcuts Sell-Product-scroll modal-products'>
            <div className=' dk-flex-sale'>
              {/* dk-mobile-hide */}
              {getQuickKeysDetails.length > 0 ? (
                <QuickKeys outlet={selOutlet} />
              ) : (
                <DefaultQuickKeyLayout />
              )}
            </div>
          </CustomScrollbars>
        </>
      ) : (
        <DefaultQuickKeyLayout />
      )}
    </Modal>
  )
}

export default QuickKeysModal
